// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import Box from "@mui/material/Box";
// Data
import { useEffect, useState } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

function Emails() {
  const [dateTo, setDateTo] = useState(new Date(moment.utc()));
  const [dateFrom, setDateFrom] = useState(
    new Date(moment.utc().subtract(7, "days"))
  );
  const [data, setData] = useState();
  const [canUpdate, setCanUpdate] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(100);
  const [filters, setFilters] = useState({
    to_email: "",
    status: "",
    type: "",
  });

  const emailTypes = [
    "emailVerification",
    "walletMigration",
    // "checkInReminder",
    // "generalNotification",
  ];

  const statuses = ["success", "failed"];

  useEffect(() => {
    const load = async () => {
      if (!canUpdate) return;
      const result = await axios.get(
        `https://apim.prdt.finance/api/v1/dashboard/email-logs`,
        {
          params: {
            page: page + 1,
            limit: rowsPerPage,
            ...filters,
            sort: "-sentAt",
          },
          headers: {
            Authorization: `Bearer 3I9WWcJ9Hp33ZE40KIdQxBVlt9CS7uHEaOsF4hT1g4gK7ULfzQPzzQqLqt8lq4R0`,
          },
        }
      );
      setData(result.data);
    };

    load();
  }, [canUpdate, page, filters, rowsPerPage]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Box sx={{ width: "100%", mb: 2 }}>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                      <TextField
                        fullWidth
                        label="Email"
                        variant="outlined"
                        size="small"
                        value={filters.to_email}
                        onChange={(e) =>
                          handleFilterChange("to_email", e.target.value)
                        }
                        InputLabelProps={{ style: { color: "#fff" } }}
                        InputProps={{
                          style: {
                            color: "#fff",
                            background: "rgba(255,255,255,0.05)",
                            height: 40,
                          },
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 40,
                            alignItems: "center",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                      <TextField
                        fullWidth
                        select
                        label="Type"
                        variant="outlined"
                        size="small"
                        value={filters.type}
                        onChange={(e) =>
                          handleFilterChange("type", e.target.value)
                        }
                        InputLabelProps={{ style: { color: "#fff" } }}
                        InputProps={{
                          style: {
                            color: "#fff",
                            background: "rgba(255,255,255,0.05)",
                            height: 40,
                          },
                        }}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: { bgcolor: "#222", color: "#fff" },
                            },
                          },
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 40,
                            alignItems: "center",
                          },
                        }}
                      >
                        <MenuItem value="">All</MenuItem>
                        {emailTypes.map((type) => (
                          <MenuItem key={type} value={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                      <TextField
                        fullWidth
                        select
                        label="Status"
                        variant="outlined"
                        size="small"
                        value={filters.status}
                        onChange={(e) =>
                          handleFilterChange("status", e.target.value)
                        }
                        InputLabelProps={{ style: { color: "#fff" } }}
                        InputProps={{
                          style: {
                            color: "#fff",
                            background: "rgba(255,255,255,0.05)",
                            height: 40,
                          },
                        }}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: { bgcolor: "#222", color: "#fff" },
                            },
                          },
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 40,
                            alignItems: "center",
                          },
                        }}
                      >
                        <MenuItem value="">All</MenuItem>
                        {statuses.map((status) => (
                          <MenuItem key={status} value={status}>
                            {status}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Box>
              </MDBox>
              {data && (
                <MDBox pt={3}>
                  <TablePagination
                    component="div"
                    count={data.totalLogs}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[100]}
                    ActionsComponent={TablePaginationActions}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} of ${count}`
                    }
                    sx={{
                      color: "white !important",
                      ".MuiTablePagination-select": {
                        color: "white !important",
                      },
                      ".MuiTablePagination-selectIcon": {
                        color: "white !important",
                      },
                      ".MuiTablePagination-actions": {
                        color: "white !important",
                      },
                      ".MuiTablePagination-toolbar": {
                        color: "white !important",
                      },
                      ".MuiTablePagination-displayedRows": {
                        color: "white !important",
                      },
                      ".MuiSvgIcon-root": { color: "white !important" },
                    }}
                  />
                  <TableContainer>
                    <Table>
                      <TableBody>
                        {data.data.map((log) => (
                          <TableRow key={log._id}>
                            <TableCell
                              sx={{
                                color: "white !important",
                                borderColor: "rgba(255, 255, 255, 0.1)",
                              }}
                              align="left"
                            >
                              {log._id}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white !important",
                                borderColor: "rgba(255, 255, 255, 0.1)",
                                width: "20%",
                              }}
                              align="left"
                            >
                              {log.to_email}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white !important",
                                borderColor: "rgba(255, 255, 255, 0.1)",
                                width: "20%",
                              }}
                              align="left"
                            >
                              {log.subject}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white !important",
                                borderColor: "rgba(255, 255, 255, 0.1)",
                                width: "15%",
                              }}
                              align="left"
                            >
                              {log.type}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white !important",
                                borderColor: "rgba(255, 255, 255, 0.1)",
                                width: "10%",
                              }}
                              align="center"
                            >
                              <MDBadge
                                badgeContent={log.status}
                                color={
                                  log.status === "success" ? "success" : "error"
                                }
                                variant="gradient"
                                size="sm"
                              />
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white !important",
                                borderColor: "rgba(255, 255, 255, 0.1)",
                                width: "15%",
                              }}
                              align="left"
                            >
                              {moment(log.sentAt).format("YYYY-MM-DD HH:mm:ss")}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    component="div"
                    count={data.totalLogs}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[100]}
                    ActionsComponent={TablePaginationActions}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} of ${count}`
                    }
                    sx={{
                      color: "white !important",
                      ".MuiTablePagination-select": {
                        color: "white !important",
                      },
                      ".MuiTablePagination-selectIcon": {
                        color: "white !important",
                      },
                      ".MuiTablePagination-actions": {
                        color: "white !important",
                      },
                      ".MuiTablePagination-toolbar": {
                        color: "white !important",
                      },
                      ".MuiTablePagination-displayedRows": {
                        color: "white !important",
                      },
                      ".MuiSvgIcon-root": { color: "white !important" },
                    }}
                  />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Emails;
